<template>
  <generic-modal
    :title="$t('document signatures')"
    ref="generic_modal"
    size="fullscreen"
  >
    <article class="message is-info">
      <div class="message-header">
        <p>{{ $t("hints") }}</p>
      </div>
      <div class="message-body">
        <p>
          {{ $t("add signature boxes clicking on the button") }}
          <strong>{{ $t("add signature box") }}</strong>
        </p>
        <p>
          {{
            $t(
              "drag signature boxes to sign location and resize them as necesary"
            )
          }}
        </p>
      </div>
    </article>

    <!-- <v-lazy-image
      v-if="meta.static_file_path"
      :src="api_host + '/drive/static' + meta.static_file_path"
    /> -->
    <div ref="document_container" class="image"></div>
    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <div class="button is-primary is-rounded" @click="save">
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </div>
      <div class="button is-rounded" @click="create_signature(null)">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("add signature box") }}</span>
      </div>
      <div class="button is-rounded" @click="delete_signatures">
        <span class="icon">
          <i class="fa fa-eraser"></i>
        </span>
        <span>{{ $t("delete signatures") }}</span>
      </div>
      <div class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </div>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  api_host,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
// import VLazyImage from "v-lazy-image";
import Konva from "konva";

export default {
  name: "SignaturesModal",
  components: { GenericModal /* VLazyImage */ },
  data() {
    return {
      api_host,
      meta: {},
      error: "",
      stage: null,
    };
  },
  computed: {},
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(page) {
      let v = this;
      v.set_initial_state();
      // console.log(page);
      if (page) v.meta = page;

      var stage = new Konva.Stage({
        container: v.$refs.document_container,
        width: v.meta.dimentions.width,
        height: v.meta.dimentions.height,
      });
      v.stage = stage;
      if (v.meta.sign_areas && v.meta.sign_areas.length) {
        let areas = [...v.meta.sign_areas];
        v.meta.sign_areas = [];

        areas.map((area, aidx) => {
          v.create_signature(area);
        });
      } else v.create_signature(null);

      window
        .jQuery(v.$refs.document_container)
        .css(
          "background-image",
          "url('" + api_host + "/drive/static" + v.meta.static_file_path + "')"
        );
      window.jQuery(v.$refs.document_container).css("background-size", "auto");
      window
        .jQuery(v.$refs.document_container)
        .css("background-repeat", "no-repeat");

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let sign_areas = v.meta.sign_areas.map((area) => {
        if (area.attrs) return area.attrs;
        else return area;
      });
      v.$emit("success", { page_uuid: v.meta.uuid, sign_areas });
      v.$refs.generic_modal.close_modal();
      // console.log(data);
      // data.settings.pages = v.$refs.document.get_pages();
      // v.$root.loader(true);
      // if (!v.meta.uuid)
      //   put("/document-sign/signing-profile", data)
      //     .then(() => {
      //       v.$emit("success");
      //       v.$refs.generic_modal.close_modal();
      //     })
      //     .catch((error) => {
      //       v.error = generate_error_message_text(error);
      //     })
      //     .finally(() => {
      //       v.$root.loader(false);
      //     });
      // else
      //   post("/document-sign/signing-profile", data)
      //     .then(() => {
      //       v.$emit("success");
      //       v.$refs.generic_modal.close_modal();
      //     })
      //     .catch((error) => {
      //       v.error = generate_error_message_text(error);
      //     })
      //     .finally(() => {
      //       v.$root.loader(false);
      //     });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
    },
    set_error(error) {
      let v = this;
      v.error = error;
    },
    create_signature(opts) {
      let v = this;
      let stage = v.stage;
      var layer = new Konva.Layer();
      stage.add(layer);
      if (!opts) opts = {};

      var rect = new Konva.Rect({
        x: opts.x || 20,
        y: opts.y || 20,
        width: opts.width || 75,
        height: opts.height || 30,
        fill: "transparent",
        name: "rect",
        stroke: "red",
        strokeWidth: 2,
        draggable: true,
      });
      layer.add(rect);

      // let signature_area = { ...rect.attrs };

      v.meta.sign_areas = v.meta.sign_areas || [];
      // v.meta.sign_areas.push(signature_area);
      // if (index) v.meta.sign_areas[index] = rect;
      v.meta.sign_areas.push(rect);

      var tr = new Konva.Transformer({
        boundBoxFunc: function (oldBoundBox, newBoundBox) {
          return newBoundBox;
        },
      });

      layer.add(tr);
      // tr.attachTo(rect);
      tr.nodes([rect]);
      layer.draw();
    },
    delete_signatures() {
      let v = this;
      v.meta.sign_areas = [];
      v.stage.destroyChildren();
      v.stage.draw();
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
